import React from "react";
import Routers from "./routers/routers";
import UserPool from "./UserPool";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import MainWrapper from "./main";
import localization from "./assets/localization/localization";
import "./assets/scss/style.scss";

const App: React.FC = () => {

  return (
    <>
      <Routers />
    </>        
  );
};
export default App;
